import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';

import { ImageFromField } from '@uncinc/react-drupal-core';

import FadeWrapper from '../FadeWrapper';
import OrangeCard from '../OrangeCard';
import WysiwygField from '../WysiwygField';
import BreadcrumbsFromMenu from '../BreadcrumbsFromMenu';

import { SCREEN_MOBILE, SCREEN_NORMAL, SCREEN_TABLET, SCREEN_WIDE } from '../../config/constants';

import './style.scss';


const LandingPageHero = ({
  title,
  body,
  image = Immutable.Map(),
  link = Immutable.Map(),
  linkTitle = '',
  breadcrumbsData = [],
}) => {
  const linkUrl = (typeof link === 'object') ? link.get('alias', link.get('uri')) : link;

  return (
    <div className="LandingPageHero">
      <BreadcrumbsFromMenu
        data={breadcrumbsData}
      />
      <div className="LandingPageHero__content">
        <div className="LandingPageHero__content__inner">
          <div className="row">
            <div className="col-12 col-md-6 inner-first">
              <FadeWrapper delay={100}>
                <div className="LandingPageHero__content__inner__imageHolder">
                  {image.get('styles') && (
                    <ImageFromField
                      className="LandingPageHeroimage"
                      field={image}
                      imageStyles={new Immutable.Map({
                        [SCREEN_MOBILE]: 'landing_page_hero_image_mobile',
                        [SCREEN_TABLET]: 'landing_page_hero_image_tablet',
                        [SCREEN_NORMAL]: 'landing_page_hero_image_desktop',
                        [SCREEN_WIDE]: 'landing_page_hero_image_desktop',
                      })}
                    />
                  )}
                </div>
              </FadeWrapper>
            </div>
            <div className="col-12 col-md-6 inner-sec">
              <FadeWrapper>
                <OrangeCard className="LandingPageHero__content__inner__content">
                  <div className="LandingPageHero__content__inner__title">
                    <h1>{title}</h1>
                  </div>
                  <div className="LandingPageHero__content__inner__body">
                    <WysiwygField
                      property="schema:text"
                      html={body}
                    />
                  </div>
                  <div className="LandingPageHero__content__inner__link">
                    {linkUrl && (
                      <a className="NodeLandingPage__link" href={linkUrl}>
                        <div className="NodeLandingPage__link__inner">
                          {linkTitle}
                        </div>
                        <div className="icon icon-arrow-right icon-variant-1" />
                      </a>
                    )}
                  </div>
                </OrangeCard>
              </FadeWrapper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PropTypes.LandingPageHero = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  image: PropTypes.instanceOf(Immutable.Map),
  link: PropTypes.instanceOf(Immutable.Map),
};

PropTypes.LandingPageHero.defaultProps = {
  image: Immutable.Map(),
  link: Immutable.Map(),
};

export default LandingPageHero;
